import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-park_list",
  "use": "icon-park_list-usage",
  "viewBox": "0 0 45 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 44\" id=\"icon-park_list\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.5 0h44v44H.5z\" /><path d=\"M6 7.333h33V11H6V7.333Zm0 12.834h33v3.666H6v-3.666ZM6 33h33v3.667H6V33Z\" fill=\"#1A1A1A\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol